// generated from 103_896 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const customEventsFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("custom_events_filter"),
  // undefined: 103_794 (99.90%), defined 102 (0.10%)
  blocklisted: z.literal(true).optional(),
  comparison_key: z.enum([
    "1", // 52_376 (50.41%)
    "3", // 45_550 (43.84%)
    "5", // 5_970 (5.75%)
  ]),
  display_name: z.string(),
  // undefined: 103_883 (99.99%), defined 13 (0.01%)
  has_hard_deleted_data: z.literal(true).optional(),
  // undefined: 47_811 (46.02%), defined 56_085 (53.98%)
  // avg: 26597.61, min: 0, max: 999999999
  raw_value: z.int().min(0).optional(),
  // avg: 9639594.02, min: 0, max: 999999999999
  value: z.int().min(0),
  varies_by_app_group: z.literal(true),
});
